import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M12 21.333h2.667V10.667H12zm5.333 0H20V10.667h-2.667zm-1.333 8q-2.766 0-5.2-1.05a13.5 13.5 0 0 1-4.233-2.85q-1.8-1.8-2.85-4.233T2.667 16t1.05-5.2 2.85-4.233 4.233-2.85 5.2-1.05 5.2 1.05 4.233 2.85 2.85 4.233 1.05 5.2-1.05 5.2a13.5 13.5 0 0 1-2.85 4.233q-1.8 1.8-4.233 2.85t-5.2 1.05"
    }, null, -1)
  ]))]))
}
export default { render: render }